var S;
((a) => {
  ((t) => {
    t[t.Contact = 0] = "Contact", t[t.Emergency = 1] = "Emergency";
  })(a.ProfileTypeEnum || (a.ProfileTypeEnum = {})), ((t) => {
    t[t.Unknown = 0] = "Unknown", t[t.Staff = 1] = "Staff", t[t.Student = 2] = "Student", t[t.Parent = 3] = "Parent";
  })(a.PersonTypeEnum || (a.PersonTypeEnum = {}));
})(S || (S = {}));
export {
  S as contacts
};
//# sourceMappingURL=index.js.map
